import {
  InformationCircleOutline,
  CalendarOutline,
  CheckmarkDone,
  ConstructOutline,
  AttachOutline,
  ReceiptOutline,
  RemoveCircleOutline,
  PulseOutline,
  CheckmarkCircleOutline,
} from 'react-ionicons';
import { ReactComponent as DeliveryParcel } from 'assets/images/delivery-parcel.svg';
import { RecentItemStatus } from '../utils';

export const recentUpdateItemIcon: Record<string, React.ReactNode> = {
  [RecentItemStatus.CIRCUIT_POSTED]: (
    <InformationCircleOutline color="#94A3B8" width="20px" height="20px" />
  ),
  [RecentItemStatus.INSTALL_CONFIRMED]: (
    <CalendarOutline color="#94A3B8" width="20px" height="20px" />
  ),
  [RecentItemStatus.FOC_RECEIVED]: (
    <CalendarOutline color="#94A3B8" width="20px" height="20px" />
  ),
  [RecentItemStatus.ORDER_SHIPPED]: (
    <DeliveryParcel color="#94A3B8" width="20px" height="20px" />
  ),
  'Order delivered': (
    <DeliveryParcel color="#94A3B8" width="20px" height="20px" />
  ),
  [RecentItemStatus.INSTALL_COMPLETED]: (
    <CheckmarkCircleOutline color="#94A3B8" width="20px" height="20px" />
  ),
  'Order completed': (
    <CheckmarkDone color="#94A3B8" width="20px" height="20px" />
  ),
  'Construction finished': (
    <ConstructOutline color="#94A3B8" width="20px" height="20px" />
  ),
  'New file attached': (
    <AttachOutline color="#94A3B8" width="20px" height="20px" />
  ),
  'Site survey completed': (
    <ReceiptOutline color="#94A3B8" width="20px" height="20px" />
  ),
  [RecentItemStatus.ORDER_CANCELED]: (
    <RemoveCircleOutline color="#94A3B8" width="20px" height="20px" />
  ),
  'Status changed': <PulseOutline color="#94A3B8" width="20px" height="20px" />,
};
